import { render, staticRenderFns } from "./StockView.vue?vue&type=template&id=2ee5e6a6&scoped=true"
import script from "./StockView.vue?vue&type=script&lang=js"
export * from "./StockView.vue?vue&type=script&lang=js"
import style0 from "./StockView.vue?vue&type=style&index=0&id=2ee5e6a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee5e6a6",
  null
  
)

export default component.exports